import { Box, CssBaseline } from "@mui/material"
import TextBox from "../components/TextBox"
import NavAppBar from "../components/NavAppBar"
import { Container } from "@mui/system"
import { useAuth } from "../context/AuthProvider"
import dataService from '../services/Data'

export const Perfil = () => {
    const { user } = useAuth()
    const data = user.data
    dataService.setToken(user.data.token)
    return (
        <>
            <CssBaseline />
            <NavAppBar />
            <Container style={{ maxWidth: 1400 }} >
                <Box display="flex" justifyContent="center" margin="dense">
                    <h2>Perfil</h2>
                </Box>
                <Box
                    component="form"
                    sx={{
                        '& .MuiTextField-root': { m: 1 },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <TextBox margen="dense" soloLectura={true} bigSize={false} requerido={false} id="1" etiqueta="Código" valorDefecto={data.usuarioID} visible={false} />
                    <TextBox margen="dense" soloLectura={true} bigSize={false} requerido={false} id="2" etiqueta="Nombre" valorDefecto={data.nombre} />
                    <TextBox margen="dense" soloLectura={true} bigSize={false} requerido={false} id="3" etiqueta="Apellido" valorDefecto={data.apellido} />
                    <TextBox margen="dense" soloLectura={true} bigSize={false} requerido={false} id="4" etiqueta="Usuario" valorDefecto={data.usuario} />
                    <TextBox margen="dense" soloLectura={true} bigSize={false} requerido={false} id="5" etiqueta="Email" valorDefecto={user.data.email} />
                    <TextBox margen="dense" soloLectura={true} bigSize={false} requerido={false} id="6" etiqueta="Celular" valorDefecto={user.data.celular} />
                </Box>
            </Container>
        </>
    )
}